import { useContext } from 'react'
import { getGatewayFromPaymentMethod } from '../../components/Payment/PinflagPaymentMethodList'
import { DataContext } from '../../context/DataContext'
import { KLAP, OTHERS, WEBPAY } from '../../constants/payment'
import { useNativePayment } from './useNativePayment'
import { useKlap } from './gateways/useKlap'
import { usePayment } from './usePayment/usePayment'
import { usePay } from './usePay'
import { doesCompanyHasPinflagPayments } from '../../components/PaymentMethodSelection'
import { useWebpay } from './gateways/useWebpay'

export const usePaymentHandlers = ({ scrapperClient }) => {
  const { payWithNativeMethod, handlePaymentMethodSelectionForOtherPayments } =
    useNativePayment({ scrapperClient, effectsActive: false })

  const {
    isPayingWithPinflagMethods,
    setPaymentState,
    setHasConfirmedPaymentMethod,
    selectedPaymentOption,
    selectedNativePaymentMethod,
    useOneClick,
    selectedPaymentCard,
    gateway
  } = usePayment()
  const { handleConfirmPinflagPaymentMethod, handleConfirmPayment } = usePay()
  const { canUserPayWithKlap } = useKlap()
  const { canUserPayWithWebpay } = useWebpay()

  const { companyInfo } = useContext(DataContext)

  const { ownPayments } = companyInfo

  const canUserGoToPayWithNativeMethods = () => {
    return selectedNativePaymentMethod !== ''
  }

  const canUserPayWithOneClick = () => {
    return useOneClick && selectedPaymentCard !== null
  }

  const canUserPayWithGateway = () => {
    switch (gateway) {
      case KLAP:
        return canUserPayWithKlap()
      case WEBPAY:
        return canUserPayWithWebpay()
      default:
        return false
    }
  }

  const canUserGoToPayWithGateway = () => {
    return selectedPaymentOption !== '' && selectedPaymentOption !== OTHERS
  }

  const canUserPayWithPinflagMethods = () => {
    return canUserPayWithOneClick() || canUserGoToPayWithGateway() || canUserGoToPayWithNativeMethods()
  }

  const canUserGoToPay = () => {
    if (doesCompanyHasPinflagPayments(ownPayments)) {
      return canUserPayWithPinflagMethods()
    } else {
      return canUserGoToPayWithNativeMethods()
    }
  }

  const handleConfirmPaymentMethod = async () => {
    setHasConfirmedPaymentMethod(true)
    // Check if is using pinflag methods
    if (!isPayingWithPinflagMethods) {
      return await payWithNativeMethod()
    }
    await handleConfirmPinflagPaymentMethod()
  }

  const onSelectPaymentMethod = (paymentMethodOption) => {
    const gateway = getGatewayFromPaymentMethod(
      ownPayments,
      paymentMethodOption
    )
    setPaymentState((prevState) => ({
      ...prevState,
      selectedPaymentCard: {},
      useOneClick: false,
      isPayingWithPinflagMethods: paymentMethodOption.type !== OTHERS,
      isSavingCard: false,
      gateway,
      selectedPaymentOption: paymentMethodOption.type
    }))
    if (paymentMethodOption.type === OTHERS) {
      handlePaymentMethodSelectionForOtherPayments(paymentMethodOption)
    }
  }

  const handleSelectCard = (card) => {
    setPaymentState((prevState) => ({
      ...prevState,
      selectedPaymentCard: card,
      selectedPaymentOption: '',
      hasConfirmedPaymentMethod: false,
      isPayingWithPinflagMethods: true,
      useOneClick: true
    }))
  }

  return {
    canUserGoToPay,
    canUserPayWithGateway,
    onSelectPaymentMethod,
    handleConfirmPaymentMethod,
    handleSelectCard,
    handleConfirmPayment
  }
}
